import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class ThemeService {  
  setCustomTheme(property) {
    this.setActiveTheme(property);
  }

  setActiveTheme(properties?): void {
     Object.keys(properties).forEach(property => {
        document.documentElement.style.setProperty(
          property,
          properties[property]
        );
      });
  }
}
